import type { Id } from '../../../aliases'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type RegisterClientResponsePayload = {
  clientId: Id
}

export const RegisterClientResponsePayloadSchema: CborSchema<RegisterClientResponsePayload> =
  defineCborSchema<RegisterClientResponsePayload>({
    clientId: CborField({ key: 0 }),
  })
